// extracted by mini-css-extract-plugin
export default {"modalOverlay":"lD-z","modalContent":"mD-z","header":"nD-z","close":"oD-z"};